import styled from "styled-components";


const OverflowSpan = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    >svg{
        margin-left: 0.25rem;
        margin-right: 0.5rem;
    }
`;

export default OverflowSpan;
